import { combineReducers } from 'redux';

const defaultReport = {
  loading: false,
  loaded: false,
  data: [],
};

const createReport = KIND => (state = defaultReport, { type, payload }) => {
  switch (type) {
    case `${KIND}_REPORT_SUCCESS`:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: payload,
      };
    case `${KIND}_REPORT_REQUEST`:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case `${KIND}_REPORT_FAILURE`:
      return {
        ...state,
        loading: true,
        loaded: false,
        errors: payload.errors,
      };
    case `${KIND}_REPORT_CLEAR`:
      return { ...defaultReport };
    default:
      return state;
  }
};

const defaultInstallerPaperwork = {
  loading: false,
  loaded: false,
  paperwork_url: null,
  count: null,
};

const installerPaperwork = (state = defaultInstallerPaperwork, { type, payload }) => {
  switch (type) {
    case 'INSTALLER_PAPERWORK_SUCCESS':
      return {
        ...state,
        loading: false,
        loaded: true,
        paperwork_url: payload.paperwork_url,
        count: payload.count,
      };
    case 'INSTALLER_PAPERWORK_REQUEST':
      return {
        ...state,
        paperwork_url: null,
        count: null,
        loading: true,
        loaded: false,
      };
    case 'INSTALLER_PAPERWORK_FAILURE':
      return {
        ...state,
        loading: true,
        loaded: false,
        errors: payload.errors,
      };
    case 'INSTALLER_PAPERWORK_CLEAR':
      return { ...defaultInstallerPaperwork };
    default:
      return state;
  }
};

const defaultTagsBulkPrint = {
  loading: false,
  loaded: false,
  tags: null,
  count: null,
};

const tagsBulkPrint = (state = defaultTagsBulkPrint, { type, payload }) => {
  switch (type) {
    case 'TAG_BULK_PRINT_SUCCESS':
      return {
        ...state,
        loading: false,
        loaded: true,
        tags: payload,
        count: payload.length,
      };
    case 'TAG_BULK_PRINT_REQUEST':
      return {
        ...state,
        tags: null,
        count: null,
        loading: true,
        loaded: false,
      };
    case 'TAG_BULK_PRINT_FAILURE':
      return {
        ...state,
        loading: true,
        loaded: false,
        errors: payload.errors,
      };
    case 'TAG_BULK_PRINT_CLEAR':
      return { ...defaultTagsBulkPrint };
    default:
      return state;
  }
};

export default combineReducers({
  installerPaperwork,
  warehouse: createReport('WAREHOUSE'),
  installWorkorder: createReport('INSTALL_WORKORDER'),
  jobHistory: createReport('JOB_HISTORY'),
  activity: createReport('ACTIVITY'),
  tagsBulkPrint,
});

const getWarehouse = state => state.warehouse;

export {
  getWarehouse,
};



// WEBPACK FOOTER //
// ./client/app/reducers/reports.js